import { ReactElement } from "react";
import { SubTitle } from "components/UIComponents/SubTitle";
import { useAppDispatch } from "lib/redux/hooks";
import { menuEditorActions } from "features/editor/editorSlice";
import { AperitifItem } from "features/editor/MenuDocumentModel";
import { EditorItem } from "features/editor/editorUtils";
import { AperitifPresetValues } from "lib/api/aperitifMenu";
import { AperitifPresetForm } from "./AperitifForm";

export interface AperitifEditorProps {
    aperitifItem: EditorItem<AperitifItem>
}

export function AperitifEditor({ aperitifItem }: AperitifEditorProps): ReactElement {
    const dispatch = useAppDispatch();
    const itemKey = aperitifItem.itemKey;
    const item = aperitifItem.menuItem;

    function onChange<T extends keyof AperitifPresetValues>(field: T, value: AperitifPresetValues[T]) {
        dispatch(menuEditorActions.editItem({
            key: itemKey,
            newItem: { ...item, [field]: value }
        }));
    }

    return (
        <div className="flex flex-col gap-4">
            <div className="px-6"><SubTitle>{item.name}</SubTitle></div>
            <div className="px-6">
                <AperitifPresetForm values={item} onChange={onChange} />
            </div>
        </div>
    );
}
